<div class="case-brief-editor">
    <div class="flex align-items-start justify-content-between flex-wrap gap-2 mb-3">
        <div class="flex flex-column">
            <label class="p-float-label flex label-color font-medium">{{ "Key.CaseBrief" | translate }}</label>
            <span class="text-gray-500 text-sm mt-1">{{ "Key.CaseBriefDescription" | translate }}</span>
        </div>
        <div class="flex gap-2">
            <p-button data-cy="button-case-brief-add-text" icon="pi pi-align-left" iconPos="left"
                styleClass="p-button-outlined p-button-sm case-brief-action-btn" [disabled]="disabled"
                label="{{ 'Key.CaseBriefAddTextBlock' | translate }}" (onClick)="addTextBlock()"></p-button>
            <p-button data-cy="button-case-brief-add-table" icon="pi pi-table" iconPos="left"
                styleClass="p-button-outlined p-button-sm case-brief-action-btn" [disabled]="disabled"
                label="{{ 'Key.CaseBriefAddTableBlock' | translate }}" (onClick)="addTableBlock()"></p-button>
        </div>
    </div>

    <div *ngIf="brief.blocks.length === 0" class="case-brief-empty text-gray-500 text-sm">
        <i class="pi pi-info-circle mr-2"></i>{{ "Key.CaseBriefEmpty" | translate }}
    </div>

    <div *ngFor="let block of brief.blocks; index as bi; trackBy: trackByIndex" class="case-brief-block mb-3">
        <div class="flex align-items-center justify-content-between gap-2 mb-2">
            <div class="flex align-items-center gap-2 flex-1">
                <span class="block-badge" [ngClass]="block.type === 'table' ? 'block-badge-table' : 'block-badge-text'">
                    <i class="pi" [ngClass]="block.type === 'table' ? 'pi-table' : 'pi-align-left'"></i>
                    {{ (block.type === 'table' ? 'Key.CaseBriefTableBlock' : 'Key.CaseBriefTextBlock') | translate }}
                </span>
                <input type="text" pInputText class="flex-1 block-title-input" [disabled]="disabled"
                    placeholder="{{ 'Key.CaseBriefBlockTitle' | translate }}"
                    [(ngModel)]="block.title" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChanged()" />
            </div>
            <div class="flex gap-1">
                <p-button icon="pi pi-arrow-up" styleClass="p-button-text p-button-sm p-button-secondary"
                    [disabled]="disabled || bi === 0" pTooltip="{{ 'Key.CaseBriefMoveUp' | translate }}"
                    (onClick)="moveBlock(bi, -1)"></p-button>
                <p-button icon="pi pi-arrow-down" styleClass="p-button-text p-button-sm p-button-secondary"
                    [disabled]="disabled || bi === brief.blocks.length - 1" pTooltip="{{ 'Key.CaseBriefMoveDown' | translate }}"
                    (onClick)="moveBlock(bi, 1)"></p-button>
                <p-button icon="pi pi-trash" styleClass="p-button-text p-button-sm p-button-danger"
                    [disabled]="disabled" pTooltip="{{ 'Key.CaseBriefRemoveBlock' | translate }}"
                    (onClick)="removeBlock(bi)"></p-button>
            </div>
        </div>

        <!-- Metin bloğu -->
        <ng-container *ngIf="block.type === 'text'">
            <p-editor class="w-full case-brief-text-editor" [formats]="formats" [readonly]="disabled"
                [style]="{ height: '180px' }" [(ngModel)]="block.html" [ngModelOptions]="{standalone: true}"
                (ngModelChange)="onChanged()">
                <ng-template pTemplate="header">
                    <span class="ql-formats">
                        <button type="button" class="ql-bold" aria-label="Bold"></button>
                        <button type="button" class="ql-italic" aria-label="Italic"></button>
                        <button type="button" class="ql-underline" aria-label="Underline"></button>
                        <button type="button" class="ql-list" value="ordered" aria-label="Ordered List"></button>
                        <button type="button" class="ql-list" value="bullet" aria-label="Bullet List"></button>
                    </span>
                </ng-template>
            </p-editor>
        </ng-container>

        <!-- Tablo bloğu -->
        <ng-container *ngIf="block.type === 'table'">
            <!-- Tablonun hemen üstünde gösterilen açıklama (Word'deki gibi) -->
            <textarea pInputTextarea rows="2" class="w-full mb-2 table-description-input" [disabled]="disabled"
                placeholder="{{ 'Key.CaseBriefTableDescription' | translate }}" [autoResize]="true"
                [(ngModel)]="block.description" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChanged()"></textarea>
            <div class="case-brief-table-wrap">
                <table class="case-brief-table">
                    <thead>
                        <tr>
                            <th *ngFor="let col of block.columns; index as ci; trackBy: trackByIndex">
                                <div class="flex align-items-center gap-1">
                                    <input type="text" pInputText class="w-full table-cell-input table-head-input" [disabled]="disabled"
                                        placeholder="{{ 'Key.CaseBriefColumnPlaceholder' | translate }}"
                                        [(ngModel)]="block.columns[ci]" [ngModelOptions]="{standalone: true}"
                                        (ngModelChange)="onChanged()" />
                                    <p-button icon="pi pi-times" styleClass="p-button-text p-button-sm p-button-secondary"
                                        [disabled]="disabled || block.columns.length <= 1"
                                        pTooltip="{{ 'Key.CaseBriefRemoveColumn' | translate }}"
                                        (onClick)="removeColumn(block, ci)"></p-button>
                                </div>
                            </th>
                            <th class="row-action-col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of block.rows; index as ri; trackBy: trackByIndex">
                            <td *ngFor="let col of block.columns; index as ci; trackBy: trackByIndex">
                                <input type="text" pInputText class="w-full table-cell-input" [disabled]="disabled"
                                    [(ngModel)]="block.rows[ri][ci]" [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="onChanged()" />
                            </td>
                            <td class="row-action-col">
                                <p-button icon="pi pi-minus" styleClass="p-button-text p-button-sm p-button-secondary"
                                    [disabled]="disabled" pTooltip="{{ 'Key.CaseBriefRemoveRow' | translate }}"
                                    (onClick)="removeRow(block, ri)"></p-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="flex gap-2 mt-2">
                <p-button icon="pi pi-plus" styleClass="p-button-text p-button-sm case-brief-action-btn" [disabled]="disabled"
                    label="{{ 'Key.CaseBriefAddRow' | translate }}" (onClick)="addRow(block)"></p-button>
                <p-button icon="pi pi-plus" styleClass="p-button-text p-button-sm case-brief-action-btn" [disabled]="disabled"
                    label="{{ 'Key.CaseBriefAddColumn' | translate }}" (onClick)="addColumn(block)"></p-button>
            </div>
        </ng-container>
    </div>
</div>
